import {UNITS as units} from './system/units/unit.constants';
import {CONSTANTS as clvs} from './system/classificators/classificator-value.constants';
import {PROPERTIES} from './system/properties/property.constants';
import {PRIVILEGES} from "./system/users/privilege.constants";
import {USERS} from "./system/users/privilege.constants";

export class GLOBAL {
  public static Units = units;
  public static Classificators = clvs;
  public static Properties = PROPERTIES;
  public static Privileges = PRIVILEGES;
  public static Users = USERS;
}
